import { render, staticRenderFns } from "./Leyes-decretos.vue?vue&type=template&id=6fc3b2dc&scoped=true"
import script from "./Leyes-decretos.vue?vue&type=script&lang=js"
export * from "./Leyes-decretos.vue?vue&type=script&lang=js"
import style0 from "./Leyes-decretos.vue?vue&type=style&index=0&id=6fc3b2dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc3b2dc",
  null
  
)

export default component.exports